module.exports = __webpack_public_path__ + "resource/img/Pretoxic.2531c4c3.png";